import { render, staticRenderFns } from "./CaptchaBlock.vue?vue&type=template&id=9d9ad886&"
import script from "./CaptchaBlock.vue?vue&type=script&lang=js&"
export * from "./CaptchaBlock.vue?vue&type=script&lang=js&"
import style0 from "./CaptchaBlock.vue?vue&type=style&index=0&id=9d9ad886&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports